import axios from "axios";

export default function finalizeShippingOrder(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/shipping-order/finalize`, {
        shipping_order_uuid: uuid,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
